<template>
  <div class="page">
    <top-header></top-header>
    <!--<h3 class="text-center mt-3 mb-0">Welcome To</h3>
		<p><img src="../assets/logo.png" style="max-width:150px"></p>-->
    <b-container class="py-2" fluid>
      <b-row class="">
        <b-col>
          <!-- <b-img src="../assets/logo-white.png" style="max-width:120px" class="mt-3"></b-img> -->
        </b-col>
        <b-col cols="12">
          <!-- <h1 class="text-center mt-0">{{$session.get('portal_name')}}</h1> -->
          <center>
            <b-img src="../assets/logo-black.png" style="max-width:100px;" id="logoimg" class=" mt-0"></b-img>
          </center>
          <h1 class="head text-center mt-0">{{ $session.get("portal_name") }}</h1>
          <h3 class="head1 text-center mt-0 ">Water Management System</h3>
        </b-col>
        <b-col> </b-col>
      </b-row>
    </b-container>
    <b-container class="mt-5 text-center">
      <b-row>
        <b-col md="6">
          <b-card img-src="../assets/pump.jpg" img-alt="Card image" img-width="100px" img-left>
            <b-card-text>
              <h3 class="mt-2">PUMPS STATUS</h3>
            </b-card-text>
            <b-link class="text-center h-100" :href="$session.get('dashboard_pumps')">
              <center><b-button class="normal-button">Go</b-button></center></b-link
            >
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card img-src="../assets/level.jpg" img-alt="Card image" img-width="100px" img-left>
            <b-card-text>
              <h3 class="mt-2">WATER LEVEL</h3>
            </b-card-text>
            <b-link class="text-center h-100" href="/dashboard/waterlevel">
              <center><b-button class="normal-button">Go</b-button></center></b-link
            >
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="bg-blue py-1 px-1" style="position:fixed; bottom:0px" fluid>
      <b-row style="margin-top: 10px;">
        <b-col>
          <h6 class="text-left">Contact Us: +91 9999 488 177, +91 9871 324 887</h6>
        </b-col>
        <b-col>
          <h6 class="text-center">www.acumecenterprises.com</h6>
        </b-col>
        <b-col>
          <h6 class="text-right">sales@acumecenterprises.com</h6>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: "Login",
  components: {
    "top-header": Header,
  },
  mounted() {
    //this.initload();
  },
  data() {
    return {
      email: "",
      password: "",
      url: this.$root.httpurl + "api-wms/dashboard",
    };
  },
  methods: {},
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-image: none !important;
}
.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}
.head {
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.head1 {
  font-family: calibri;
  margin-top: -15px !important;
}

.mt-xl {
  margin-top: 100px;
}
.btn-black {
  background-color: #000;
  color: #fff;
  padding: 6px 25px;
}
#logoimg {
  justify-content: center !important;
}
.info-box2 {
  display: block;
  min-height: 90px;
  background-color: #fff;
  width: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  margin-bottom: 15px;
}
</style>
